<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <a
      v-if="disabled && value"
      :href="getValidURL(value)"
      target="_blank"
      class="accent--text"
      style="background-color: white"
    >
      {{ value }}
    </a>

    <input
      v-else
      :value="value"
      @input="updateValue($event.target.value)"
      type="text"
      :disabled="disabled"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";

export default {
  name: "InputTypeUrlNPV",

  mixins: [inputTypeMixin],

  methods: {
    getValidURL(url) {
      if (url.includes("https://")) {
        return url;
      } else {
        return "https://" + url;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/InputTypesNPV/InputTypeUrlNPV.vue